import GoogleMapsLoader from 'google-maps/lib/Google';
import debounce from 'es6-promise-debounce/src/es6-promise-debounce';

GoogleMapsLoader.KEY = 'AIzaSyAc4gF4vE1I6eADntZGn6vkPPFdvK1sufs';

export default class Map {
    constructor(mapElement, options) {
        this.geocoder = null;
        this.instance = null;
        this.$mapElement = jQuery(mapElement);
        this.options = {
            address: 'UK',
            icon: false,
            title: 'Marker',
            zoom: 14,
        };
        Object.assign(this.options, options);

        GoogleMapsLoader.load((google) => {
            this.google = google;

            this.geocoder = new google.maps.Geocoder();
            this.geocoder.geocode({
                address: this.options.address,
            }, (results) => {
                this.init(results[0].geometry.location);
            });

            this.init();
        });
    }

    init(location) {
        this.instance = new this.google.maps.Map(this.$mapElement[0], {
            center: location,
            zoom: this.options.zoom,
            disableDefaultUI: true,
            scrollwheel: false,
            zoomControl: true,
            zoomControlOptions: {
                position: this.google.maps.ControlPosition.TOP_RIGHT,
                style: this.google.maps.ZoomControlStyle.SMALL,
            },
        });

        new this.google.maps.Marker({
            position: location,
            map: this.instance,
            title: this.options.title,
            icon: this.options.icon,
        });

        this.location = location;
        this.resize();
    }

    resize() {
        const debouncedFunction = debounce(() => {
            return new Promise((resolve) => {
                resolve();
            });
        }, 200);
        jQuery(window).resize(() => {
            debouncedFunction().then(() => {
                this.instance.setCenter(this.location);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./scripts/app/map.js